import axios from 'axios';
import { API_URL } from '../../utils/constants';
import { isValidFullPhone, normPhoneDigits } from '../../utils/phoneCountryCodes';

const catalogClient = axios.create({
  baseURL: `${API_URL}/public/catalog`,
  timeout: 12000,
});

catalogClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const normWhatsappDigits = (value) => normPhoneDigits(value);

export const hasCatalogWhatsapp = (user) =>
  isValidFullPhone(user?.catalogWhatsapp);

export const productInterestPayload = (product) => {
  if (!product) return {};
  return {
    producto: {
      nombre: product.nombre,
      marca: product.marca,
      talla: product.talla,
      color: product.color,
      categoria: product.categoria,
      precio_venta: product.precio_venta,
    },
  };
};

export const fetchInterestProductIds = (slug) =>
  catalogClient.get('/intereses/ids', { params: { slug } }).then((r) => r.data);

export const saveCatalogInterest = (payload) =>
  catalogClient.post('/intereses', payload).then((r) => r.data);

export const removeCatalogInterest = (slug, productId) =>
  catalogClient.delete(`/intereses/${productId}`, { params: { slug } }).then((r) => r.data);

export const updateCatalogContact = (whatsapp) =>
  catalogClient
    .patch('/me/contact', { whatsapp })
    .then((r) => r.data);
